// // src/components/Navbar.js
// import React from 'react';
// // src/pages/HomePage.js
// import '../components/Navbar.css';
// import 'font-awesome/css/font-awesome.min.css';



// const Navbar = () => {
//   return (
//     <nav className="navbar">
//       <div className="logo">
//       <i className="fa fa-bell"></i>
      
//       </div>

//       <div className="nav-links">
//         <a href="#features">Features</a>
//         <a href="#howitworks">How It Works</a>
//         <a href="#download">Download</a>
//       </div>

      
//     </nav>
//   );
// };

// export default Navbar;




// import React from 'react';
// import Navbar from './Navbar';
// import Hero from './Hero';
// import WorkSection from '../components/WorkSection'; // Correct path to the WorkSection.js file


// import CardSection from '../components/CardSection';
// import Footer from './Footer';


// const HomePage = () => {
//     return (
//       <div>
//         <Navbar /> {/* Render the Navbar */}
//         <Hero/>
//         <CardSection />
//         <WorkSection/>
//         <Footer/>
//       </div>
//     );
//   };
  

// export default HomePage;




import React from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import WorkSection from '../components/WorkSection'; // Correct path to the WorkSection.js file
import CardSection from '../components/CardSection';
import Footer from './Footer';

const HomePage = () => {
  return (
    // <div>
    //   <Navbar /> {/* Render the Navbar */}
    //   <div id="features"> <Hero /> </div>  {/* Hero Section with id "features" */}
    //   <div id="download"> <CardSection /> </div>
    //   <div id="howitworks"> <WorkSection /> </div> {/* Work Section with id "howitworks" */}
    //    {/* Card Section */}
    //   <Footer /> {/* Footer Section */}
    // </div>
    <div>
     <Navbar /> 
     <Hero />
   <div id="features"> <CardSection /> </div>
   <div id="howitworks"> <WorkSection /> </div>
   <div id="download"> <Footer /> </div>
</div>
  );
};

export default HomePage;







